import { Stack } from 'expo-router';
import { Platform, useWindowDimensions } from 'react-native';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

/** Stable component identity for React Navigation — do not call getScreenTitleHeader() inside render. */
const drawerAccountStackHeader = getScreenTitleHeader({
  backStyle: 'back',
  cannotGoBackHref: '/account',
});
export default function DrawerLayout() {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === 'web' && width >= 768;

  return (
    <Stack
      screenOptions={{
        header: drawerAccountStackHeader,
      }}
    >
      <Stack.Screen
        name="account/info"
        options={{
          title: 'My Account',
        }}
      />
      <Stack.Screen
        name="account/other-terms"
        options={{
          title: 'Other Terms & Policies',
          headerShown: !isDesktopWeb,
        }}
      />
      <Stack.Screen
        name="account/payment"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="account/gift-cards"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="diagnostics"
        options={{
          title: 'Diagnostics',
        }}
      />
    </Stack>
  );
}
